import React, { useState } from "react";
import "@/App.css";
import BreathingBackground from "@/components/BreathingBackground";
import BottomTabs from "@/components/BottomTabs";
import HomeTab from "@/components/HomeTab";
import ChatTab from "@/components/ChatTab";
import InsightsTab from "@/components/InsightsTab";
import ProfileTab from "@/components/ProfileTab";

function App() {
  const [activeTab, setActiveTab] = useState("home");

  return (
    <div
      data-testid="app-shell"
      className="app-shell select-none font-outfit"
      style={{ backgroundColor: "#020202" }}
    >
      <BreathingBackground activeTab={activeTab} />

      <div className="tab-content">
        <div className={`tab-panel ${activeTab === "home" ? "active" : ""}`}>
          {activeTab === "home" && <HomeTab />}
        </div>
        <div className={`tab-panel ${activeTab === "chat" ? "active" : ""}`}>
          <ChatTab />
        </div>
        <div className={`tab-panel ${activeTab === "insights" ? "active" : ""}`}>
          {activeTab === "insights" && <InsightsTab />}
        </div>
        <div className={`tab-panel ${activeTab === "profile" ? "active" : ""}`}>
          {activeTab === "profile" && <ProfileTab />}
        </div>
      </div>

      <BottomTabs activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
}

export default App;
